import styled from 'styled-components'

export const Overlay = styled.div`
  height: 100%;
  width: 100%;
  opacity: 0.4;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 9999;
  }
`
